import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelToSentenceCase' })
//Convert a camelCase text to a Sentence Case. Example helloThere -> Hello There
export class CamelToSentenceCase implements PipeTransform {
  transform(camelCase: string): string {
    if (camelCase) {
      const result = camelCase.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return '';
  }
}
